export const futureShowDict = {
  'harvelles-revival-6.27.25': {
    id: 'harvelles-revival-6.27.25',
    imgSrc: 'harvelles-6.27.25.png',
    date: "6/27/2025",
    shortDate: "6/27/25",
    name: "Harvelle's Santa Monica",
    liveAt: `
        <span>Super OK live at</span>
        <a target="_blank" href="https://www.instagram.com/harvellessm/">Harvelle's Santa Monica</a>`,
    venueDetails: [`<i>21+</i>`, '$10', "<a href='https://santamonica.harvelles.com/shows/316361'>Buy tickets" + " now</a>", `Or at the door`],
    link: `https://santamonica.harvelles.com/shows/316361`,
    address: `1432 4th Street Santa Monica 90401`,
    shortLocation: 'Santa Monica, CA',
    addressLink: `https://maps.app.goo.gl/B9bffTsyTFFJXjBs9`,
  },
};

export const futureShowList = [];
